import React from "react";
import PropTypes from "prop-types";

import pricingFeatureInterface from "./pricingFeatureInterface";


const PricingFeatureInput = (props) => {

  const {dbFeature, property, onBlur, onChange, disabled, value, defaultValue, className} = props;

  return (
    <input type="text"
           className={"pr-input color-textgray border-box font--14 pl-05 pr-05 radius-5 width-100 " + (className || "")}
           name={property}
           data-id={dbFeature.featureDefinition_id}
           data-ids={dbFeature.fabricatorFeatureIds}
           data-default={defaultValue}
           value={value}
           autoComplete="off"
           onBlur={onBlur}
           disabled={disabled}
           onChange={onChange}/>
  )
};

PricingFeatureInput.propTypes = {
  dbFeature: PropTypes.shape(pricingFeatureInterface).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default PricingFeatureInput
